import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/TC_vid_2026_Sep_GetStarted.png'


const _withScopeId = n => (_pushScopeId("data-v-5f7bd16e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "with-subhead" }, "Frequently Asked Questions", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subhead" }, "Updated Feb 9, 2024", -1))
const _hoisted_4 = { class: "list-unstyled toc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "what-is-tree-crossing" }, "What is Tree Crossing?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "what-is-sync-app" }, "What is the Sync app?", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Genealogists use Tree Crossing Sync to easily publish their data from their favorite genealogy program. When any new changes are made in their genealogy program, it can automatically sync the changes to treecrossing.com. The sync app never makes changes to the tree data file on the computer.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "learn-how" }, "How do I get started with Tree Crossing?", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our first priority is to make sure the software is intuitive and guides you so that you will not need to read manuals or tutorials. That said, sometimes learning materials can be helpful.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We are working on a series of tutorials and guides. In the meantime, here is a full demo of how to get your first tree uploaded to Tree Crossing.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Getting Started with Tree Crossing"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "How to Get Started with Tree Crossing - Full Walk-through", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<h4 id=\"can-upload-gedcom\" data-v-5f7bd16e>Can I upload a GEDCOM?</h4><p data-v-5f7bd16e>You don&#39;t have to! Tree Crossing uploads data directly from your genealogy program through an installed sync app, to upload your tree and keep it up to date. Benefits include:</p><ul data-v-5f7bd16e><li data-v-5f7bd16e>Less mess – Keep working on your main tree in your genealogy program; no need to export anything.</li><li data-v-5f7bd16e>Privacy without extra work – the sync app omits sensitive details on upload of living people; no need to create a scrubbed GEDCOM for upload.</li><li data-v-5f7bd16e>Photos &amp; documents included – media attached in your genealogy program upload with your tree.</li></ul><p data-v-5f7bd16e>Support for GEDCOM is being considered for those who only have their tree in a GEDCOM file and do not intend to further develop their tree.</p><h4 id=\"what-is-explore\" data-v-5f7bd16e>What app do family members use?</h4><p data-v-5f7bd16e>Family members simply visit TreeCrossing.com after getting an invitation from a tree owner. Mobile devices are supported, however, your family will find that the best way to have a discovery-focused experience is on a larger screen, such as a tablet or computer.</p><h4 id=\"plans\" data-v-5f7bd16e>Is Tree Crossing free?</h4><p data-v-5f7bd16e>Yes. Tree Crossing offers a free service, as well as paid subscriptions that add more features and abilities. See the <a href=\"/plans\" data-v-5f7bd16e>plans</a> page for details. </p><h4 id=\"free-browsing\" data-v-5f7bd16e>Do family members need a paid subscription to access my tree(s)?</h4><p data-v-5f7bd16e>No. Family members that you invite do not need to pay, and are free to explore your trees, no matter what subscription plan you choose.</p><h4 id=\"will-my-tree-be-public\" data-v-5f7bd16e>Will my tree data be visible to the public?</h4>", 11)
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#cousin-bait" }, "cousin bait", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "how-different" }, "How is Tree Crossing different from other online tree services?", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Other services provide features best suited for genealogy enthusiasts and experts, and are primarily focused on research and tree-building activities. Tree Crossing offers those same enthusiats a way to share their tree data with their family members in an experience specifically designed for exploring. ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Using Tree Crossing versus other online services is not an either/or decision. Our genealogist-minded members may continue to use other online services in "),
  /*#__PURE__*/_createElementVNode("em", null, "addition"),
  /*#__PURE__*/_createTextVNode(" to Tree Crossing, so that their family members who have less genealogical experience now have a way enjoy the family tree.")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "research-tool" }, "Is Tree Crossing a tree-building or research tool?", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No. You build it, we make it shareable in the best possible way for your family.", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "after", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If you are just getting started creating your tree, visit the "),
  /*#__PURE__*/_createElementVNode("a", { href: "/signup/family" }, "get started"),
  /*#__PURE__*/_createTextVNode(" page, which will walk you through the steps, including suggestions of what software to use.")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "tree-copy" }, "I'm not a genealogist. Can I use a family tree someone else gave me?", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "no-tree" }, "I don't have a family tree. Can I still use Tree Crossing?", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We are working on making it easier for people without a family tree to get started. In the meantime, the best option is to reach out to someone in the family that you know might have a tree they can upload and invite you to.", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "compatibility" }, "What software is compatible with Tree Crossing?", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "fs-compatibility" }, "Is Tree Crossing compatible with FamilySearch?", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Our sync app is compatible with desktop apps that already integrate with FamilySearch. This allows you to sync to both FamilySearch and Tree Crossing as desired. Direct sync from FamilySearch Family Tree is also being considered. ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "cousin-bait" }, "What is \"cousin bait\"?", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " \"Cousin bait\" is a popular term in the industry that refers to putting a family tree online, publicly visible, possibly hosted with multiple sites and services, in hopes that a relative (distant cousin) might discover and reach out to you. The idea is to try and connect with others that might have more information about your family lines. ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "data-limits" }, "Is there a limit to the number of trees or names in a tree?", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There is currently a limit of 1 tree you can upload on the free plan and more trees depending on the paid plans.", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There is no limit of names per tree. However, some people choose to split their trees into multiple family lines using desktop software before uploading, so that they can manage the data separately while still having it all appear as one tree for their family members.", -1))

import { trackClick } from '@/util/Analytics'

export default /*#__PURE__*/_defineComponent({
  __name: 'FAQPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#what-is-tree-crossing" }, {
          default: _withCtx(() => [
            _createTextVNode("What is Tree Crossing?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#what-is-sync-app" }, {
          default: _withCtx(() => [
            _createTextVNode("What is the Sync app?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#learn-how" }, {
          default: _withCtx(() => [
            _createTextVNode("How do I get started with Tree Crossing?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#can-upload-gedcom" }, {
          default: _withCtx(() => [
            _createTextVNode("Can I upload a GEDCOM?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#what-is-explore" }, {
          default: _withCtx(() => [
            _createTextVNode("What app do family members use?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#plans" }, {
          default: _withCtx(() => [
            _createTextVNode("Is Tree Crossing free?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#free-browsing" }, {
          default: _withCtx(() => [
            _createTextVNode("Do family members need a paid subscription to access my tree(s)?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#will-my-tree-be-public" }, {
          default: _withCtx(() => [
            _createTextVNode("Will my tree data be visible to the public?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#how-different" }, {
          default: _withCtx(() => [
            _createTextVNode("How is Tree Crossing different from other online tree services?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#research-tool" }, {
          default: _withCtx(() => [
            _createTextVNode("Is Tree Crossing a tree-building or research tool?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#tree-copy" }, {
          default: _withCtx(() => [
            _createTextVNode("I'm not a genealogist. Can I use a family tree someone else gave me?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#no-tree" }, {
          default: _withCtx(() => [
            _createTextVNode("I don't have a family tree. Can I still use Tree Crossing?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#compatibility" }, {
          default: _withCtx(() => [
            _createTextVNode("What software is compatible with Tree Crossing?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#fs-compatibility" }, {
          default: _withCtx(() => [
            _createTextVNode("Is Tree Crossing compatible with FamilySearch?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#cousin-bait" }, {
          default: _withCtx(() => [
            _createTextVNode("What is \"cousin bait\"?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "#data-limits" }, {
          default: _withCtx(() => [
            _createTextVNode("Is there a limit to the number of trees or names in a tree?")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_5,
    _createElementVNode("p", null, [
      _createTextVNode("Genealogists use Tree Crossing to share their research with family members, offering them a safe, connected and fun way to learn about their family history. You can read more about our company on our "),
      _createVNode(_component_router_link, { to: { name: 'about' } }, {
        default: _withCtx(() => [
          _createTextVNode("about page")
        ]),
        _: 1
      }),
      _createTextVNode(".")
    ]),
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("p", null, [
      _createTextVNode("Supported platforms and data we sync is available on the "),
      _createVNode(_component_router_link, { to: { name: 'sync' } }, {
        default: _withCtx(() => [
          _createTextVNode("sync page")
        ]),
        _: 1
      }),
      _createTextVNode(".")
    ]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _createElementVNode("a", {
      class: "video-tile",
      href: "https://www.youtube.com/watch?v=eFNnTUnXmp4",
      target: "_blank",
      rel: "noopener",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackClick)('faq_vid_GetStarted', { section: 'faq', id: 'faq_vid_GetStarted', target: 'youtube' })))
    }, _hoisted_13),
    _hoisted_14,
    _createElementVNode("p", null, [
      _createTextVNode("No. Only you can see it by default, and you decide who else you allow to view your tree. We may also offer you the option to share limited portions of your data to the public and to search engines, which is commonly referred to as \""),
      _hoisted_25,
      _createTextVNode("\". If you are interested in this, please "),
      _createVNode(_component_router_link, { to: { name: 'support', hash: '#contact' } }, {
        default: _withCtx(() => [
          _createTextVNode("let us know")
        ]),
        _: 1
      }),
      _createTextVNode("!")
    ]),
    _hoisted_26,
    _hoisted_27,
    _hoisted_28,
    _hoisted_29,
    _hoisted_30,
    _createElementVNode("p", null, [
      _createTextVNode(" Tree Crossing is not in the online records business or the research and tree-building business. Other "),
      _createVNode(_component_router_link, { to: { name: 'research' } }, {
        default: _withCtx(() => [
          _createTextVNode("existing software and services")
        ]),
        _: 1
      }),
      _createTextVNode(" do a great job in those areas. We help you do something amazing with your research "),
      _hoisted_31,
      _createTextVNode(" you have family data you want to share. ")
    ]),
    _hoisted_32,
    _hoisted_33,
    _createElementVNode("p", null, [
      _createTextVNode("Yes. Make sure your tree is in a "),
      _createVNode(_component_router_link, { to: { name: 'sync', hash: '#app-support' } }, {
        default: _withCtx(() => [
          _createTextVNode("compatible genealogy program")
        ]),
        _: 1
      }),
      _createTextVNode(". These software programs can import a GEDCOM file, and then sync with Tree Crossing using "),
      _createVNode(_component_router_link, { to: { name: 'sync' } }, {
        default: _withCtx(() => [
          _createTextVNode("Tree Crossing Sync")
        ]),
        _: 1
      }),
      _createTextVNode(".")
    ]),
    _hoisted_34,
    _hoisted_35,
    _createElementVNode("p", null, [
      _createTextVNode("Alternatively, if you plan to get started in genealogy and build your own tree, here is a "),
      _createVNode(_component_router_link, { to: { name: 'research' } }, {
        default: _withCtx(() => [
          _createTextVNode("list of helpful software and services")
        ]),
        _: 1
      }),
      _createTextVNode(" to get you started.")
    ]),
    _hoisted_36,
    _createElementVNode("p", null, [
      _createTextVNode(" Our explore experience (tree browsing) is web-based, so it works everywhere. For uploading and synchronizing trees, please see our "),
      _createVNode(_component_router_link, { to: { name: 'sync', hash: '#app-support' } }, {
        default: _withCtx(() => [
          _createTextVNode("sync app page")
        ]),
        _: 1
      }),
      _createTextVNode(" for full details on compatibility with genealogy software. ")
    ]),
    _hoisted_37,
    _hoisted_38,
    _hoisted_39,
    _hoisted_40,
    _hoisted_41,
    _hoisted_42,
    _hoisted_43,
    _createElementVNode("p", null, [
      _createTextVNode("If these limitations seem small or makes things difficult, please "),
      _createVNode(_component_router_link, { to: { name: 'support', hash: '#contact'  } }, {
        default: _withCtx(() => [
          _createTextVNode("let us know")
        ]),
        _: 1
      }),
      _createTextVNode(". We are always looking at ways to improve the service.")
    ])
  ]))
}
}

})